import { MathJax } from 'better-react-mathjax';

export const renderMathJax = (value: string) => <MathJax>{value}</MathJax>;